// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invite-share-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: inviteFadeIn 0.18s ease-out;
}

.invite-share-modal {
  width: 480px;
  max-width: 92vw;
  background: #313338;
  border-radius: 12px;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: inviteScaleUp 0.22s cubic-bezier(0.16, 1, 0.3, 1);
}

.invite-share-header {
  padding: 18px 20px 14px 20px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.invite-share-header-info h2 {
  font-size: 18px;
  font-weight: 750;
  color: #f2f3f5;
  margin: 0 0 4px 0;
}

.invite-share-header-info p {
  font-size: 13px;
  color: #949ba4;
  margin: 0;
  line-height: 1.4;
}

.invite-share-header-info p span {
  color: #dbdee1;
  font-weight: 600;
}

.invite-share-close-btn {
  background: transparent;
  border: none;
  color: #949ba4;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.invite-share-close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

.invite-share-search {
  padding: 14px 20px 8px 20px;
}

.invite-search-input-box {
  display: flex;
  align-items: center;
  background: #1e1f22;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  padding: 8px 12px;
  gap: 8px;
  transition: border-color 0.15s ease;
}

.invite-search-input-box:focus-within {
  border-color: #5865f2;
}

.invite-search-icon {
  color: #949ba4;
}

.invite-search-input-box input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #f2f3f5;
  font-size: 13.5px;
}

.invite-search-input-box input::placeholder {
  color: #80848e;
}

.invite-search-clear {
  background: transparent;
  border: none;
  color: #949ba4;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
}

.invite-share-list {
  max-height: 240px;
  overflow-y: auto;
  padding: 6px 20px 14px 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.invite-share-user-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 10px;
  border-radius: 8px;
  transition: background 0.15s ease;
}

.invite-share-user-item:hover {
  background: rgba(255, 255, 255, 0.04);
}

.invite-share-user-avatar-wrap {
  position: relative;
  width: 38px;
  height: 38px;
  min-width: 38px;
}

.invite-share-user-avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.invite-share-user-avatar-placeholder {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #5865f2;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 15px;
}

.invite-user-status-dot {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  border: 2px solid #313338;
}

.invite-user-status-dot.online {
  background: #22c55e;
}

.invite-user-status-dot.offline {
  background: #80848e;
}

.invite-share-user-info {
  flex: 1;
  min-width: 0;
}

.invite-share-user-name {
  font-size: 14px;
  font-weight: 600;
  color: #f2f3f5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.invite-share-user-tag {
  font-size: 12px;
  color: #949ba4;
}

.invite-send-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #5865f2;
  color: #ffffff;
  border: none;
  border-radius: 5px;
  padding: 6px 14px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}

.invite-send-btn:hover:not(:disabled) {
  background: #4752c4;
}

.invite-send-btn.sent {
  background: #248046;
  color: #ffffff;
  cursor: default;
}

.invite-share-empty {
  text-align: center;
  padding: 28px 16px;
  color: #80848e;
}

.invite-share-empty p {
  margin-top: 8px;
  font-size: 13px;
}

.invite-share-bottom {
  background: #2b2d31;
  padding: 16px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.invite-share-bottom-label {
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  color: #b5bac1;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.invite-copy-input-row {
  display: flex;
  align-items: center;
  background: #1e1f22;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  padding: 3px 3px 3px 12px;
  gap: 8px;
}

.invite-copy-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #dbdee1;
  font-size: 13px;
  font-family: Consolas, monospace;
}

.invite-copy-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #5865f2;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}

.invite-copy-btn:hover {
  background: #4752c4;
}

.invite-copy-btn.copied {
  background: #248046;
}

.invite-share-footer-note {
  margin-top: 8px;
  display: flex;
  align-items: center;
  font-size: 11.5px;
  color: #949ba4;
}

@keyframes inviteFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes inviteScaleUp {
  from { transform: scale(0.95); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
`, "",{"version":3,"sources":["webpack://./src/components/InviteModal/ServerInviteShareModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,+EAA+E;EAC/E,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,4DAA4D;AAC9D;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,sBAAsB,EAAE,UAAU,EAAE;EAC3C,KAAK,mBAAmB,EAAE,UAAU,EAAE;AACxC","sourcesContent":[".invite-share-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: inviteFadeIn 0.18s ease-out;\n}\n\n.invite-share-modal {\n  width: 480px;\n  max-width: 92vw;\n  background: #313338;\n  border-radius: 12px;\n  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.08);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: inviteScaleUp 0.22s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.invite-share-header {\n  padding: 18px 20px 14px 20px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.invite-share-header-info h2 {\n  font-size: 18px;\n  font-weight: 750;\n  color: #f2f3f5;\n  margin: 0 0 4px 0;\n}\n\n.invite-share-header-info p {\n  font-size: 13px;\n  color: #949ba4;\n  margin: 0;\n  line-height: 1.4;\n}\n\n.invite-share-header-info p span {\n  color: #dbdee1;\n  font-weight: 600;\n}\n\n.invite-share-close-btn {\n  background: transparent;\n  border: none;\n  color: #949ba4;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n}\n\n.invite-share-close-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n\n.invite-share-search {\n  padding: 14px 20px 8px 20px;\n}\n\n.invite-search-input-box {\n  display: flex;\n  align-items: center;\n  background: #1e1f22;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 6px;\n  padding: 8px 12px;\n  gap: 8px;\n  transition: border-color 0.15s ease;\n}\n\n.invite-search-input-box:focus-within {\n  border-color: #5865f2;\n}\n\n.invite-search-icon {\n  color: #949ba4;\n}\n\n.invite-search-input-box input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  outline: none;\n  color: #f2f3f5;\n  font-size: 13.5px;\n}\n\n.invite-search-input-box input::placeholder {\n  color: #80848e;\n}\n\n.invite-search-clear {\n  background: transparent;\n  border: none;\n  color: #949ba4;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n}\n\n.invite-share-list {\n  max-height: 240px;\n  overflow-y: auto;\n  padding: 6px 20px 14px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.invite-share-user-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  transition: background 0.15s ease;\n}\n\n.invite-share-user-item:hover {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.invite-share-user-avatar-wrap {\n  position: relative;\n  width: 38px;\n  height: 38px;\n  min-width: 38px;\n}\n\n.invite-share-user-avatar {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.invite-share-user-avatar-placeholder {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: #5865f2;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 15px;\n}\n\n.invite-user-status-dot {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  border: 2px solid #313338;\n}\n\n.invite-user-status-dot.online {\n  background: #22c55e;\n}\n\n.invite-user-status-dot.offline {\n  background: #80848e;\n}\n\n.invite-share-user-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.invite-share-user-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #f2f3f5;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.invite-share-user-tag {\n  font-size: 12px;\n  color: #949ba4;\n}\n\n.invite-send-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #5865f2;\n  color: #ffffff;\n  border: none;\n  border-radius: 5px;\n  padding: 6px 14px;\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.invite-send-btn:hover:not(:disabled) {\n  background: #4752c4;\n}\n\n.invite-send-btn.sent {\n  background: #248046;\n  color: #ffffff;\n  cursor: default;\n}\n\n.invite-share-empty {\n  text-align: center;\n  padding: 28px 16px;\n  color: #80848e;\n}\n\n.invite-share-empty p {\n  margin-top: 8px;\n  font-size: 13px;\n}\n\n.invite-share-bottom {\n  background: #2b2d31;\n  padding: 16px 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.invite-share-bottom-label {\n  display: flex;\n  align-items: center;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  color: #b5bac1;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n}\n\n.invite-copy-input-row {\n  display: flex;\n  align-items: center;\n  background: #1e1f22;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 6px;\n  padding: 3px 3px 3px 12px;\n  gap: 8px;\n}\n\n.invite-copy-input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  outline: none;\n  color: #dbdee1;\n  font-size: 13px;\n  font-family: Consolas, monospace;\n}\n\n.invite-copy-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #5865f2;\n  color: #ffffff;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.invite-copy-btn:hover {\n  background: #4752c4;\n}\n\n.invite-copy-btn.copied {\n  background: #248046;\n}\n\n.invite-share-footer-note {\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n  font-size: 11.5px;\n  color: #949ba4;\n}\n\n@keyframes inviteFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes inviteScaleUp {\n  from { transform: scale(0.95); opacity: 0; }\n  to { transform: scale(1); opacity: 1; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
